// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2eP72","footer":"ChangeClinic_footer__VWVvX"};